import React, { useEffect } from "react";
import { Layout } from "@/components/Layout";
import { Sparkles, Lock } from "lucide-react";

const CAPABILITIES = [
  "Leggere utenti e trasferte",
  "Creare e modificare trasferte",
  "Verificare la disponibilità delle auto aziendali",
  "Leggere e creare prenotazioni",
  "Leggere hotel, trasporti e parcheggi",
  "Leggere e aggiornare gli itinerari",
  "Applicare le preferenze aziendali (aeroporti, voli diretti, soluzioni economiche)",
];

export default function AiAssistant() {
  return (
    <Layout>
      <div className="max-w-3xl">
        <div className="flex items-center gap-3 mb-2">
          <div className="h-11 w-11 rounded-xl bg-[#E30613] flex items-center justify-center text-white">
            <Sparkles size={22} />
          </div>
          <div>
            <h1 className="font-display text-3xl font-bold text-slate-900">Assistente AI Trasferte</h1>
            <p className="text-slate-500">Predisposto per l'integrazione futura.</p>
          </div>
        </div>

        <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 flex items-start gap-3 my-6" data-testid="ai-notice">
          <Lock size={18} className="text-amber-600 mt-0.5 shrink-0" />
          <p className="text-sm text-amber-800">
            L'agente AI non è ancora attivo. Il backend è però già predisposto: tutte le entità sono
            accessibili tramite API REST documentate (<span className="font-mono">/api</span>, docs su
            <span className="font-mono"> /docs</span>) così che un agente potrà interagire in sicurezza.
          </p>
        </div>

        <h2 className="font-display text-lg font-semibold text-slate-900 mb-3">Cosa potrà fare l'agente</h2>
        <div className="bg-white border border-slate-200 rounded-lg shadow-sm divide-y divide-slate-100">
          {CAPABILITIES.map((c) => (
            <div key={c} className="px-5 py-3 text-sm text-slate-700 flex items-center gap-3">
              <span className="h-1.5 w-1.5 rounded-full bg-[#E30613]" /> {c}
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
